import { type ApiResponse, FmsApi } from "../fmsapi"
import type { RESPONSE_VISITOR_REGISTRATION_STATUS, VST_sd_FAIR_MASTER_POLL, VST_sr_VisitorReqRegistCheck } from "../models/responsedto"
import BaseController from "./base"

export class VisitorController extends BaseController {
  constructor(api: FmsApi) {
    super(api, "visitor")
  }

  public async VST_sd_FAIR_MASTER_POLL(fair_master_id: number, visitor_id: number | null = null): Promise<VST_sd_FAIR_MASTER_POLL[]> {
    return await this.callApi("VST_sd_FAIR_MASTER_POLL", { fair_master_id, visitor_id })
  }

  public async checkVisitorRegistrationStatus(params: {
    fair_id: number
    name: string
    mobile: string
  }): Promise<ApiResponse<RESPONSE_VISITOR_REGISTRATION_STATUS>> {
    return await this.callApi("checkVisitorRegistrationStatus", { FAIR_ID: params.fair_id, NAME: params.name, MOBILE: params.mobile })
  }

  public async VST_sr_VisitorReqRegistCheck(params: { fair_id: number; email: string }): Promise<VST_sr_VisitorReqRegistCheck[]> {
    return await this.callApi("VST_sr_VisitorReqRegistCheck", { fair_id: params.fair_id, email: params.email })
  }
}
